<template>
  <div class="animated fadeInRight ecommerce">
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0 bg-white">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('refundCart.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="conditions" class="flex justify-start">
            <el-form-item>
              <el-input :placeholder="$t('refundCart.orderNumber')" v-model="conditions.cartId" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="conditions.state" :placeholder="$t('refundCart.selectStatus')" style="width:100%">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input :placeholder="$t('refundCart.productName')" v-model="conditions.prodName" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryOrders">{{ $t('refundCart.query') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('refundCart.refundOrder') }}</span>
          </div>
          <el-table :data="orderCarts" style="width: 100%" border>
            <el-table-column prop="cartId" :label="$t('refundCart.orderNumber')" align="center">
            </el-table-column>
            <el-table-column prop="prodName" :label="$t('refundCart.productName')" align="center">
            </el-table-column>
            <el-table-column prop="specValue" :label="$t('refundCart.productSpec')" align="center">
            </el-table-column>
            <el-table-column prop="personName" :label="$t('refundCart.userName')" align="center">
            </el-table-column>
            <el-table-column prop="returnPayPrice" :label="$t('refundCart.refundAmount')" align="center">
            </el-table-column>
            <el-table-column prop="stateName" :label="$t('refundCart.orderStatus')" align="center">
            </el-table-column>
            <el-table-column prop="returnReason" :label="$t('refundCart.refundReason')" align="center">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('refundCart.applyTime')" align="center">
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            :total="total" layout="total, prev, pager, next, jumper">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminRefundOrders } from '@/api/admin/refundCartApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  components: {
    AdminShop
  },
  data() {
    return {
      orderCarts: [],
      conditions: {
        cartId: '',
        state: '',
        prodName: '',
        shopId: ''
      },
      statusOptions: [
        { value: '', label: this.$t('refundCart.selectStatus') },
        { value: '5005', label: this.$t('refundCart.applyRefund') },
        { value: '6006', label: this.$t('refundCart.refundSuccess') },
        { value: '7007', label: this.$t('refundCart.hasRefunded') }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.listOrders()
  },
  methods: {
    handleShopChange(shop) {
      this.conditions.shopId = shop.shopId
      this.listOrders()
    },
    async listOrders() {
      const params = {
        ...this.conditions,
        page: this.currentPage,
        row: this.pageSize
      }

      const res = await queryAdminRefundOrders(params)
      this.orderCarts = res.data.map(item => {
        let specValue = ''
        if (item.productSpecDetails) {
          item.productSpecDetails.forEach(detail => {
            specValue += (detail.detailValue + "/")
          })
        }
        return {
          ...item,
          specValue: specValue || '-'
        }
      })
      this.total = res.total

    },
    queryOrders() {
      this.currentPage = 1
      this.listOrders()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listOrders()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.box-card {
  margin-bottom: 20px;
}
</style>